import client from "./client";
import type {
  EmailVerificationStatus,
  SendEmailVerificationResponse,
} from "@/types/auth";

export async function getEmailVerificationStatus(): Promise<EmailVerificationStatus> {
  const res = await client.get<EmailVerificationStatus>("/auth/email/status");
  return res.data;
}

export async function sendEmailVerification(): Promise<SendEmailVerificationResponse> {
  const res = await client.post<SendEmailVerificationResponse>(
    "/auth/email/send-verification"
  );
  return res.data;
}

export async function confirmEmailVerification(token: string): Promise<void> {
  await client.post("/auth/email/verify", { token });
}
